import React from "react";
import Header from "../../Components/Header/Header";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import LeaderItems from "./LeaderItems/LeaderItems";

const AboutLeader = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Breadcrumb title={t("Şirkətimizin Qurucusu")} />

      <LeaderItems />
    </>
  );
};

export default AboutLeader;
